export default "__VITE_ASSET__BelWk_18__"